import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, loginTelegram } from '../api';

export default function Login() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const result = await login(credentials);
      if (result.ok && result.data) {
        // Store token and redirect
        localStorage.setItem('ubuntu_token', result.data.token);
        navigate('/');
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleTelegramLogin = async () => {
    setError('');
    setLoading(true);
    
    try {
      // In production, Telegram WebApp SDK passes initData
      const displayName = 'Test User';
      const result = await loginTelegram(displayName);
      if (result.ok && result.data) {
        localStorage.setItem('ubuntu_token', result.data.token);
        navigate('/');
      } else {
        setError(result.error || 'Telegram login failed');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="text-4xl mb-2">🏘️</div>
          <h1 className="text-2xl font-bold text-gray-900">Ubuntu Town</h1>
          <p className="text-gray-600 mt-1">Your community, your power</p>
        </div>
        
        {/* Login Form */}
        <form onSubmit={handleSubmit} className="card">
          <h2 className="text-xl font-bold mb-4">Log In</h2>
          
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-red-700 text-sm mb-4">
              {error}
            </div>
          )}
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                className="input"
                placeholder="Enter your email"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="input"
                placeholder="Enter your password"
                required
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-50"
            >
              {loading ? 'Logging in...' : 'Log In'}
            </button>
            
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="bg-white px-2 text-gray-500">Or</span>
              </div>
            </div>
            
            <button
              type="button"
              onClick={handleTelegramLogin}
              disabled={loading}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 px-4 rounded-xl font-medium active:scale-95 transition-transform disabled:opacity-50"
            >
              📱 Log in with Telegram
            </button>
          </div>
        </form>
        
        {/* Sign Up Link */}
        <p className="text-center text-gray-600 mt-4">
          Don't have an account?{' '}
          <button className="text-ubuntu-green font-medium">Sign Up</button>
        </p>
      </div>
    </div>
  );
}
